module.exports = __webpack_public_path__ + "candle.jpg?28ab29621dc85ff8e64b7d8b065f2f45";